import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class OccupationQuery extends UncubesQuery {
  projection = 'ticket_sales'

  cuts = []

  aggregates = [
    { kpi: 'ticket_line_quantity', function: 'SUM' }]

  limit = 25

  constructor(pointOfSaleGuid, dateStart, dateEnd, isManaged = false) {
    super();
    this.cuts = [
      { expression: 'product_diners_quantity_reference = 1' },
      { expression: `point_of_sale_guid = '${pointOfSaleGuid}'` },
      { expression: `ticket_line_date between '${dateStart}' and '${dateEnd}'` }];
    if (isManaged) {
      this.cuts.push({ expression: "sale_rate_is_managed = '1'" });
    }
  }
}
